import ToggleIconLinkButton from 'components/ToggleIconLinkButton';
import CAT_CONSTANTS from 'lookup/CatConstants';
import React, { useState } from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { MdAdd, MdRemove } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { getDynamicSwitchGroupDiff } from 'views/Cat/CompareCodexVersion/UpdatedDSGDetails/UpdatedDynamicSwitchGroupDetails.actions';
import { getDynamicSwitchGroup } from 'views/Cat/DynamicSwitchGroupDetails/DynamicSwitchGroupDetails.actions';
import DrugOptionBoxCompact from './DrugOptionBox/DrugOptionBoxCompact';

const SingleDynamicSwitchOptionType = ({ itemType, hideInactive }) => {
  const dispatch = useDispatch();
  
  // Get state from Redux using useSelector
  const allowEditing = useSelector((state) => {
    return state.codexVersion?.isWorkingVersionEditable && 
           state.dynamicSwitchGroupDetails?.allowEditing && 
           !state.dynamicSwitchGroupDetails?.showDelta
      ? state.dynamicSwitchGroupDetails.allowEditing 
      : false;
  });
  const showDelta = useSelector((state) => 
    state.dynamicSwitchGroupDetails ? state.dynamicSwitchGroupDetails.showDelta : false
  );
  const workingCodexVersionId = useSelector((state) => 
    state.codexVersion ? state.codexVersion.codexVersionId : null
  );
  const dynamicSwitchGroupId = useSelector((state) => 
    state.dynamicSwitchGroupDetails?.dynamicSwitchGroup 
      ? state.dynamicSwitchGroupDetails.dynamicSwitchGroup.dynamicSwitchGroupId 
      : null
  );
  const dsoList = useSelector((state) => {
    if (itemType == CAT_CONSTANTS.dynamicSwitchOptionTypeLabels.TARGET) {
      return state.dynamicSwitchGroupDetails ? state.dynamicSwitchGroupDetails.targetDrugs : [];
    } else if (itemType == CAT_CONSTANTS.dynamicSwitchOptionTypeLabels.SWITCH) {
      return state.dynamicSwitchGroupDetails ? state.dynamicSwitchGroupDetails.switchDrugs : [];
    } else {
      return state.dynamicSwitchGroupDetails ? state.dynamicSwitchGroupDetails.auxiliaryDrugs : [];
    }
  });
  const [isExpandedMode, setIsExpandedMode] = useState(true);

  const toggleExpandedMode = () => {
    setIsExpandedMode(!isExpandedMode);
  }

  // TODO: This should be moved to the parent components where the API calls are actually made he first time
  const refreshList = () => {
    if(!showDelta) {
      dispatch(getDynamicSwitchGroup(dynamicSwitchGroupId));
    } else {
      dispatch(getDynamicSwitchGroupDiff(workingCodexVersionId, dynamicSwitchGroupId));
    }
  }
  return (
    dsoList && dsoList.length > 0 ?
      <div className={"dso-single-option-type"}>
        <Row>
          <Col>
            <div className="dynamic-switch-option-type-label">
              <span>{itemType}</span>
              <span className="pull-right">
                <ToggleIconLinkButton
                  shouldDisplayFirstTag={isExpandedMode}
                  toggleButton={toggleExpandedMode}
                  FirstIcon={MdRemove}
                  firstTag={"Collapse"}
                  SecondIcon={MdAdd}
                  secondTag={"Expand"}
                  linkClassName={"main-button-link"}
                />
              </span>
            </div>
          </Col>
        </Row>
        <Collapse in={isExpandedMode}>
          <div>
            {
              dsoList.filter(i => (!hideInactive || i.currentDynamicSwitchOption.isActive)
                && (!showDelta || !i.currentDynamicSwitchOption.isDeleted || i.oldDynamicSwitchOption)).map((dynamicSwitchOption, idx) =>
                <DrugOptionBoxCompact
                  dynamicSwitchOption={dynamicSwitchOption.currentDynamicSwitchOption}
                  oldDynamicSwitchOption={dynamicSwitchOption.oldDynamicSwitchOption}
                  otherDynamicSwitchOptions={dynamicSwitchOption.otherDynamicSwitchOptions}
                  allowEditing={allowEditing}
                  showDelta={showDelta}
                  workingCodexVersionId={workingCodexVersionId}
                  refreshList={refreshList}
                  dynamicSwitchGroupId={dynamicSwitchGroupId}
                  hideInactive={hideInactive}
                  id={`option-${idx}`}
                  key={`option-${idx}`}
                 />
              )
            }
          </div>
        </Collapse>
      </div>
      : null
  )
}
export default SingleDynamicSwitchOptionType;